const n = {
  // padding: '8px 8px 2px 8px',
  borderBottom: "none"
}, a = {
  // padding: '0 8px',
  // fontSize: '12px',
  // lineHeight: '17px',
}, c = {
  padding: "8px",
  borderRadius: "4px",
  maxHeight: "300px",
  maxWidth: "600px"
};
function e() {
  return {
    color: "#fff",
    textColor: "var(--gray-500)",
    titleColor: "var(--gray-900)"
  };
}
function T() {
  return {
    color: "var(--gray-900)",
    textColor: "#fff"
  };
}
const i = (r) => {
  var t;
  const o = {
    light: () => e(),
    dark: () => T()
  };
  return ((t = o[r]) == null ? void 0 : t.call(o)) || {};
};
export {
  a as TOOLTIP_CONTENT_STYLES,
  n as TOOLTIP_HEADER_STYLES,
  c as TOOLTIP_STYLE_OVERRIDES,
  i as createTooltipTheme
};
